import React from "react";

const AfishaCard = ({ item }) => {
  return (
    <div className="afisha-card">
      <img
        className="border-radius"
        src={`${process.env.REACT_APP_IMG_SERVER}/img/${item.cover_img}/mobile`}
        alt=""
      />
      <p>{item.title}</p>
    </div>
  );
};

export default AfishaCard;



// WEBPACK FOOTER //
// ./src/components/Events/AfishaCard.js